import Input from "../Input";
import { useEffect, useState } from "react";
import { TimePickerProps } from ".";
import { default as BaseTimePicker } from "@mui/lab/TimePicker";
import { Box } from "@mui/material";

export default function TimePicker({
  onChange,
  editable,
  StartIcon,
  InputFieldProps,
  value: { date: value = "" },
  ...rest
}: TimePickerProps) {
  const [open, setOpen] = useState(false);
  const isSmallScreen = window.innerWidth < 900;
  const closePicker = () => {
    (document.activeElement as HTMLElement | null)?.blur?.();
    setOpen(false);
  };

  useEffect(() => {
    return () => {
      (document.activeElement as HTMLElement | null)?.blur?.();
    };
  }, []);

  const InputProps = {
    autoComplete: "off",
    id: "time",
    InputLabelProps: { shrink: true },
    ...InputFieldProps,
    onClick: () => setOpen(true),
    onKeyDown: (e: any) => {
      if (!editable) e.preventDefault();
    },
    error: InputFieldProps?.helperText ? InputFieldProps?.error : false,
  };

  return (
    <>
      {StartIcon ? (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            paddingLeft: "10px",
            borderRadius: "4px",
          }}
        >
          <StartIcon style={{ fontSize: "18px", color: "#939399" }} />
          <BaseTimePicker
            open={open}
            ampm={true}
            value={value}
            showTodayButton
            ampmInClock={true}
            onOpen={() => setOpen(true)}
            onClose={closePicker}
            onChange={(date: Date | null) =>
              onChange?.({ date: date ? `${date}` : "", error: false })
            }
            onAccept={(date: Date | null) =>
              {
                onChange?.({ date: date ? `${date}` : "", error: false });
                closePicker();
              }
            }
            onError={(reason: any, date: Date | null) => {
              if (!reason) return;
              onChange?.({ date: date ? `${date}` : "", error: true });
            }}
            {...rest}
            renderInput={(params: any) => <Input {...params} {...InputProps} />}
            PopperProps={{ placement: "bottom-start", ...rest.PopperProps }}
          />
        </Box>
      ) : (
        <BaseTimePicker
        
          open={open}
          ampm={true}
          value={value}
          showTodayButton
          ampmInClock={true}
          onOpen={() => setOpen(true)}
          onClose={closePicker}
          onChange={(date: Date | null) =>
            onChange?.({ date: date ? `${date}` : "", error: false })
          }
          onAccept={(date: Date | null) =>
            {
              onChange?.({ date: date ? `${date}` : "", error: false });
              closePicker();
            }
          }
          onError={(reason: any, date: Date | null) => {
            if (!reason) return;
            onChange?.({ date: date ? `${date}` : "", error: true });
          }}
          {...rest}
          renderInput={(params: any) => <Input {...params} {...InputProps} />}
          PopperProps={{ placement: "bottom-start", ...rest.PopperProps }}
        />
      )}
    </>
  );
}
